import { render, staticRenderFns } from "./profile-bookings.vue?vue&type=template&id=05ca2c41&scoped=true&"
import script from "./profile-bookings.ts?vue&type=script&lang=ts&"
export * from "./profile-bookings.ts?vue&type=script&lang=ts&"
import style0 from "./profile-bookings.scss?vue&type=style&index=0&id=05ca2c41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca2c41",
  null
  
)

export default component.exports